import React, { useState, useMemo } from 'react';
import '../styles/peopleTable.css';

const PeopleTable = ({ people, isEnriched, onEnrichContacts, onViewProfile }) => {
  // console.log('people--->', people);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
  const [filter, setFilter] = useState('');
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectAll, setSelectAll] = useState(false);
  const itemsPerPage = 10;

  const handleCheckboxChange = (person) => {
    setSelectedContacts(prev => {
      const newSelection = prev.some(contact => contact.id === person.id)
        ? prev.filter(contact => contact.id !== person.id)
        : [...prev, person];
      
      // Update selectAll state based on whether all items are selected
      if (newSelection.length === filteredPeople.length) {
        setSelectAll(true);
      } else {
        setSelectAll(false);
      }
      
      return newSelection;
    });
  };

  const handleViewProfile = (linkedinUrl) => {
    if (onViewProfile) {
      onViewProfile(linkedinUrl);
    }
  };

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setSelectAll(isChecked);
    
    if (isChecked) {
      setSelectedContacts(filteredPeople);
    } else {
      setSelectedContacts([]);
    }
  };

  const handleEnrichClick = () => {
    if (selectedContacts.length > 0) {
      onEnrichContacts(selectedContacts);
    }
  };

  const handleImageClick = (imageUrl, e) => {
    e.stopPropagation();
    setSelectedImage(imageUrl);
  };

  const handleCloseModal = () => {
    setSelectedImage(null);
  };

  const sortedPeople = useMemo(() => {
    let sortablePeople = [...people];
    if (sortConfig.key !== null) {
      sortablePeople.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }
    return sortablePeople;
  }, [people, sortConfig]);

  const formatPerson = (person) => {
    // console.log("person data--->",person , isEnriched)
    const formatLocation = () => {
      if (person.location) return person.location;
      const city = person.city || '';
      const country = person.country || '';
      return city && country ? `${city}, ${country}` : city || country || 'N/A';
    };

    return {
      name: person.name || `${person.first_name} ${person.last_name}`,
      title: person.title || 'N/A',
      company: person.company || person.company_name || person.organization_name || (person.organization && person.organization.name) || 'N/A',
      location: formatLocation(),
      email: person.email === 'email_not_unlocked@domain.com' ? isEnriched ? "N/A" : 'Locked' : (person.email || 'N/A'),
      phone: person.phone_numbers && person.phone_numbers.length > 0 ? person.phone_numbers[0].number : 'N/A',
      linkedin_url: person.linkedin_url || 'N/A'
    };
  };

  const filteredPeople = sortedPeople.filter(person => {
    const searchStr = filter.toLowerCase();
    const formattedPerson = formatPerson(person);
    return Object.values(formattedPerson).some(value =>
      value.toString().toLowerCase().includes(searchStr)
    );
  });

  // Pagination calculations
  const totalPages = Math.ceil(filteredPeople.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredPeople.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    // Don't clear selections when changing pages
  };

  const requestSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  return (
    <div className="people-table-container">
      <table className="people-table table-container">
        <thead>
          <tr>
            {/* {isEnriched && <th>Select</th>} */}
            <th>
              <input
                type="checkbox"
                onChange={handleSelectAll}
                checked={selectAll}
                className="cursor-pointer"
              />
            </th>
            <th className='tableName' onClick={() => requestSort('name')} > Name {sortConfig.key === 'name' && (sortConfig.direction === 'ascending' ? '▲' : '▼')}</th>
            <th onClick={() => requestSort('title')}>Title {sortConfig.key === 'title' && (sortConfig.direction === 'ascending' ? '▲' : '▼')}</th>
            <th onClick={() => requestSort('company')}>Company {sortConfig.key === 'company' && (sortConfig.direction === 'ascending' ? '▲' : '▼')}</th>
            <th onClick={() => requestSort('location')}>Location {sortConfig.key === 'location' && (sortConfig.direction === 'ascending' ? '▲' : '▼')}</th>
            {/* <th>Email</th>
            <th>Phone</th>*/}
            <th>LinkedIn</th>
          </tr>
        </thead>
        <tbody>
          {currentItems.map((person, index) => {
            const formattedPerson = formatPerson(person);
            return (
              <tr key={person.id || index}>
                <td>
                  <input
                    type="checkbox"
                    checked={selectedContacts.some(contact => contact.id === person.id)}
                    onChange={() => handleCheckboxChange(person)}
                  />
                </td>

                <td title={formattedPerson.name}>
                  <div className="name-cell">
                    {person.photo_url && (
                      <img
                        src={person.photo_url}
                        alt=""
                        className="people-list-profile-img"
                        onClick={(e) => handleImageClick(person.photo_url, e)}
                        style={{ cursor: 'pointer' }}
                      />
                    )}
                    <span>{formattedPerson.name}</span>
                  </div>
                </td>
                <td title={formattedPerson.title}>{formattedPerson.title}</td>
                <td title={formattedPerson.company}> {formattedPerson.company}</td>
                <td title={formattedPerson.location}>{formattedPerson.location}</td>

                <td>
                  {formattedPerson.linkedin_url !== 'N/A' && formattedPerson.linkedin_url ? (
                    <a
                      href={formattedPerson.linkedin_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="linkedin-link"
                      onClick={(e) => {
                        e.preventDefault(); // Prevent default link behavior
                        handleViewProfile(formattedPerson.linkedin_url); // Trigger the profile scraper
                      }}
                    >
                      Profile
                    </a>
                  ) : (
                    'N/A'
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className="table-footer">
        <div className="find-people-pagination-container">
          <div className="pagination-info">
            <p>Total people found: {filteredPeople.length}</p>
          </div>
          <div className="pagination-controls">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="pagination-button chevron"
              aria-label="Previous page"
            >
              ‹
            </button>
            <span className="pagination-range">
              page {currentPage} of {totalPages}
            </span>
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="pagination-button chevron"
              aria-label="Next page"
            >
              ›
            </button>
          </div>
        </div>
        <button
          onClick={handleEnrichClick}
          disabled={selectedContacts.length === 0}
          className={`${selectedContacts.length === 0 ? 'opacity-50' : 'enrich-selected-btn'}`}
        >
          Enrich Selected Contacts ({selectedContacts.length})
        </button>
      </div>
      {selectedImage && (
        <div
          className="image-modal-overlay"
          onClick={handleCloseModal}
        >
          <div className="image-modal">
            <div className="image-modal-header">
              <button className="close-button" onClick={handleCloseModal}>×</button>
            </div>
            <img
              src={selectedImage}
              alt=""
              className="image-modal-content"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default PeopleTable;